import { formatLedgerMoney, todayIso, apiErrorMessage } from '@/utils/ledger'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

function monthStart() {
  const date = new Date()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  return `${date.getFullYear()}-${month}-01`
}

export default {
  data() {
    const now = new Date()
    return {
      company: false,
      loading: false,
      report: null,
      date: todayIso(),
      from: monthStart(),
      to: todayIso(),
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      asOf: todayIso(),
    }
  },
  computed: {
    canCompany() {
      return this.hasPermission('view company_reports')
    },
    scopeParams() {
      return this.company && this.canCompany ? { scope: 'company' } : {}
    },
    scopeLabel() {
      const scope = this.report && this.report.scope
      if (!scope) return ''
      return scope.scope === 'company' ? this.$t('ledger_rep_company') : this.$t('ledger_rep_branch')
    },
  },
  methods: {
    money(value) {
      return formatLedgerMoney(value || 0, this.$i18n.locale)
    },
    toastError(error) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: apiErrorMessage(error, this.$t('ledger_error')),
          icon: 'AlertCircleIcon',
          variant: error?.response?.status === 422 ? 'warning' : 'danger',
        },
      })
    },
    printReport() {
      window.print()
    },
  },
}
